import React from "react";

const ValidationErrorsSummary = ({
  validationErrors,
  renderAsHtml = false,
}) => {
  if (!validationErrors || Object.keys(validationErrors).length === 0) {
    return null;
  }
  return (
    <div className="upsell-validation">
      <div
        className="alert alert-danger text-left"
        role="alert"
      >
        <span className="fa fa-exclamation"></span>{" "}
        <strong className="text-black">Please check the following:</strong>
        <ul>
          {Object.values(validationErrors).map((errorObj, idx) => {
            const messages = errorObj.message;
            return Array.isArray(messages) ? (
              messages.map((msg, msgIdx) => (
                <li
                  key={`${idx}-${msgIdx}`}
                  {...(renderAsHtml
                    ? { dangerouslySetInnerHTML: { __html: msg } }
                    : { children: msg })}
                />
              ))
            ) : (
              <li
                key={idx}
                {...(renderAsHtml
                  ? { dangerouslySetInnerHTML: { __html: messages } }
                  : { children: messages })}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default ValidationErrorsSummary;
